<template>
	<div class="index">
		<template v-if="userDatalt.id">
			<div class="page-mine" v-if="userDatalt.isDealer">
				<div class="top-part">
					<div class="bg-card">
						<div class="card-item">
							<div class="user-info layout-left-center w-full" style="justify-content:space-between;">
								<div class="avatar">
									<div class="user-avatar van-image">
										<img class="van-image__img">
										<div class="van-image__loading">
											<img :src="userDatalt.avatar" alt="" class="user-avatar">
										</div>
									</div>
								</div>
								<div
									style="flex:1; color: #fff;font-size: var(--base-px-20);padding-left: var(--base-px-16)">
									{{ userDatalt.name }}
								</div>
								<!--                                <img src="../../assets/my/settle.png" alt="" style="width: 16.99px;">-->
								<div style="color: #fff;" @click="logout">退出登录</div>
							</div>
							<div class="detail-wrapper layout-side">
								<div class="h-full" style="width: 50%;">
									<div class="detail-wrapper-title" style="font-size: var(--base-px-12)">
										账户余额<span v-if="is_recharge" style="text-decoration: underline" @click="goRecharge">去充值</span>
									</div>
									<div class="detail-wrapper-title" style="margin-top: var(--base-px-3)">{{
										userDatalt.red_balance
									}}
									</div>
								</div>
								<div class="h-full"
									style="width: 50%;border-left: var(--base-px-1) solid #FFFFFF;padding-left: var(--base-px-24)">
									<div class="detail-wrapper-title" style="font-size: var(--base-px-12)">今日已发金额</div>
									<div class="detail-wrapper-title" style="margin-top: var(--base-px-3)">
										{{ userDatalt.day_already_red_number }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="event">
						<div style="display: flex;justify-content: center; align-items: center;">
							<div class="w-full layout-left-center title">群成员管理</div>
							<van-button size="mini" @click="addGroupAdmin"
								style="background: #0256FF;border-radius: 8px;font-size: 14px;white-space: nowrap;padding: 16px 16px;"
								type="info">添加群管
							</van-button>
						</div>

						<div class="search layout-left-center">
							<van-icon name="search" size="17px" />
							<div class="layout-left-center" style="width: calc(100% - var(--base-px-17))">
								<van-field placeholder="搜索" v-model="text" @input="throttledClick"
									style="padding: 0 0 0 var(--base-px-15);font-size:12px;color:#ffffff;border-radius: var(--base-px-18);background: #7C9FDA;" />
							</div>

						</div>
						<div v-if="loading" style="text-align: center;margin-top: var(--base-px-12);">
							<van-loading size="16px">加载中...</van-loading>
						</div>
						<div v-else class="event-list">
							<van-empty v-if="!groupAdmins.length" image-size="100" description="暂无数据"></van-empty>
							<div class="w-full" v-else>
								<div class="card w-full" v-for="(item, index) in groupAdmins" :key="'ga_' + index"
									@click="onClickGroup(item.employee_id)">
									<div class="top w-full layout-side">
										<!--									<div class="h-full avatar">
										<img :src="item.avatar" alt="" class="w-full h-full" style="border-radius: var(&#45;&#45;base-px-48)">
									</div>-->
										<div class="h-full content w-full">
											<div class="w-full content-top"
												style="display: flex; justify-content: space-between; align-items: center;">
												<span>{{ item.name }}</span>
												<span class="status-badge"
													:class="item.status == 1 ? 'status-enabled' : 'status-disabled'">
													{{ item.status == 1 ? '启用' : '禁用' }}
												</span>
											</div>
											<div class="w-full content-bottom">{{ item.created_at }}</div>
										</div>
									</div>
									<div class="bottom w-full layout-side">
										<div class="bottom-item">
											<div class="bottom-item-top layout-center">今日观看人数</div>
											<div class="bottom-item-bottom layout-center">{{
												item.day_watch_number }}</div>
										</div>
										<div class="bottom-item">
											<div class="bottom-item-top layout-center"
												style="border-left: var(--base-px-1) solid #DBDBDB;border-right: var(--base-px-1) solid #DBDBDB">
												今日完播人数
											</div>
											<div class="bottom-item-bottom layout-center">{{
												item.day_finished_number }}</div>
										</div>
                                        <div class="bottom-item">
                                            <div class="bottom-item-top layout-center">今日完播率</div>
                                            <div class="bottom-item-bottom layout-center">{{ item.finished_rate
                                                }}</div>
                                        </div>

                                        <!-- 新增：今日新增 -->
                                        <div class="bottom-item">
                                            <div class="bottom-item-top layout-center">今日新增</div>
                                            <div class="bottom-item-bottom layout-center">{{ item.day_new_number }}</div>
                                        </div>
										<!-- 新增：今日新增 -->
                                        <div class="bottom-item">
                                            <div class="bottom-item-top layout-center">今日发放红包</div>
                                            <div class="bottom-item-bottom layout-center">{{ item.day_red_packet_money || 0 }}</div>
                                        </div>
                                        <!-- 新增：今日注册 -->
                                        <div class=" bottom-item">
                                            <div class="bottom-item-top layout-center">今日注册</div>
                                            <div class="bottom-item-bottom layout-center">{{ item.day_register_number }}</div>
                                        </div>
									</div>
									<div class="w-full btns" style="margin-top: 12px">
										<van-button :type="item.status == 1 ? 'danger' : 'primary'" style="width: 20vw;"
											size="small"
											@click.stop="handleStatusChange(item.employee_id, item.status)">
											{{ item.status == 1 ? '禁用' : '启用' }}
										</van-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else style="padding-bottom: var(--base-px-50);">
				<Group />
			</div>
		</template>
		<van-tabbar v-model="active" class="tab">
			<van-tabbar-item replace to="/">
				<span>首页</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/home.png" />
					<img v-else src="../../assets/images/home-active.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/course/index" icon="search">
				<span>课程</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/course-active.png" />
					<img v-else src="../../assets/images/course.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/contact/index" icon="search">
				<span>客户</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/customer-active.png" />
					<img v-else src="../../assets/images/customer.png">
				</template>
			</van-tabbar-item>
			<!--			<van-tabbar-item replace to="/tool/index" icon="setting-o">-->
			<!--				<span>运营工具</span>-->
			<!--				<template #icon="props">-->
			<!--					<img v-if="props.active" src="../../assets/images/function-active.png"/>-->
			<!--					<img v-else src="../../assets/images/function.png">-->
			<!--				</template>-->
			<!--			</van-tabbar-item>-->
			<van-tabbar-item replace :to="userDatalt.isDealer ? '/my' : '/my?id=' + userDatalt.id" icon="setting-o">
				<span>{{ userDatalt.isDealer ? '我的' : '直播课' }}</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/my-active.png" />
					<img v-else src="../../assets/images/my.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item v-if="!userDatalt.isDealer&&is_live" replace to="/live/index" icon="search">
				<span>直播</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/live-active.png" />
					<img v-else src="../../assets/images/live.png">
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { userCenter } from "../../api/homePage";
import { groupManagerDetails, groupManagerList, groupManagerTrainList, employeeStatus } from "../../api/my"
import Group from "@/views/my/group.vue";
import _ from 'lodash'
import { setCookie } from "@/utils";

export default {
	components: { Group },
	data() {
		return {
			// 文字
			message: '',
			// tbas切换
			tabsChose: 0,
			// tab 切换
			active: 3,
			userDatalt: {
				id: 1,
				isDealer: true, //todo:test
				name: ''
			},
			debug: false,
			groupAdmins: [],
			text: "",
			throttledClick: null,
			loading: true,
			is_live: process.env.VUE_APP_IS_LIVE==='false' ? false : true,
			is_recharge: process.env.VUE_APP_IS_RECHARGE=='1' ? true : false,
		}
	},
	created() {
		console.log(process.env)
		if (localStorage.getItem("debug") === 'true') {
			this.debug = true
		} else {
			this.debug = false
		}
		this.userDetails()
		this.throttledClick = _.throttle(this.onSearch, 500)
	},
	watch: {},
	methods: {
		handleStatusChange(employee_id, status) {
			this.$dialog.confirm({
				title: '提示',
				message: '是否' + (status == 1 ? '禁用' : '启用') + '该群管',
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(() => {
				employeeStatus({
					employee_id,
					status: status == 1 ? 2 : 1
				}).then(res => {
					if (res.code == 1) {
						this.$message.success('操作成功')

						this.getGroupAdmins()
					}
				})
			}).catch(() => {
				console.log("用户取消");

			})
		},
		onSearch() {
			console.log(this.text)
			groupManagerList({ search: this.text }).then(res => {
				this.groupAdmins = res.data
			})
		},
		userDetails() {
			const item = JSON.parse(localStorage.getItem("userDetails"))
			if (item) {
				this.userDatalt = item
			}
			userCenter().then(res => {
				this.userDatalt = res.data
				this.userDatalt.isDealer = res.data.role == 1

				localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))

				if (this.userDatalt.isDealer) {
					this.getGroupAdmins()
				}
			})
		},
		getGroupAdmins() {
			groupManagerList().then(res => {
				this.loading = false;
				if (res.code == 1) {
					this.groupAdmins = res.data
				}

			})
		},
		switchDebug() {
			if (this.debug) {
				localStorage.setItem("debug", "true")
			} else {
				localStorage.removeItem("debug")
			}
			window.location.reload()
		},
		onClickGroup(e) {
			this.$router.push({ path: '/my/group', query: { id: e, type: "back" } })
		},
		goRecharge() {
			this.$router.push('/index/trafficRecharge')
		},
		addGroupAdmin() {
			this.$router.push('/my/addgroupadmin');
		},
		logout() {
			localStorage.removeItem('userDetails');
			setCookie('personbench_token', '');
			setCookie('person', '');
			this.$router.push('/login')
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-tabbar {
	box-sizing: content-box !important;
}

.index {
	.tab {
		justify-content: space-between;
	}

	font-size: var(--base-px-14);
	height: 100%;
	background: #F1f2f5;

	:deep(.van-field__control) {
		color: #ffffff;
	}

	p {
		margin: 0 !important;
	}

	.fs14 {
		font-size: var(--base-px-14);
	}

	.fs16 {
		font-size: var(--base-px-16);
	}

	.page-mine {
		position: relative;
		min-height: 100%;
		background: #f2f3f7;

		.top-part {
			height: 100%;
			width: 100%;

			.bg-card {
				background: linear-gradient(180deg, #3974c7, #0a42c3 55%, #2b63cd);

				.card-item {
					width: 100%;
					height: var(--base-px-220);
					background: url(../../assets/images/background-my.png) no-repeat 50%/contain;
					background-size: 100% 100%;
					padding: var(--base-px-28) var(--base-px-40) 0;

					.user-info {
						.avatar {
							cursor: pointer;

							.user-avatar {
								width: var(--base-px-48);
								height: var(--base-px-48);
								border-radius: var(--base-px-48);
								-o-object-fit: cover;
								object-fit: cover;
								position: relative;
								display: inline-block;

								.van-image__img {
									display: block;
									width: 100%;
									height: 100%;
									border-radius: var(--base-px-48);
								}

								.van-image__loading {
									width: 100%;
									height: 100%;
									position: absolute;
									top: 0;
									left: 0;
									display: -webkit-box;
									display: -webkit-flex;
									display: flex;
									-webkit-box-orient: vertical;
									-webkit-box-direction: normal;
									-webkit-flex-direction: column;
									flex-direction: column;
									-webkit-box-align: center;
									-webkit-align-items: center;
									align-items: center;
									-webkit-box-pack: center;
									-webkit-justify-content: center;
									justify-content: center;
									color: #969799;
									font-size: var(--base-px-14);
									background-color: #f7f8fa;
									border-radius: var(--base-px-48);

									img {
										width: var(--base-px-48);
										height: var(--base-px-48);
										border-radius: var(--base-px-48);
										-o-object-fit: cover;
										object-fit: cover;
									}

								}
							}
						}
					}

					.detail-wrapper {
						background: #dbedff7d;
						border-radius: var(--base-px-4) var(--base-px-4) var(--base-px-4) var(--base-px-4);
						border: var(--base-px-1) solid rgba(255, 255, 255, 0.17);
						height: var(--base-px-62);
						margin-top: var(--base-px-10);
						padding: var(--base-px-10) var(--base-px-24);

						&-title {
							height: var(--base-px-22);
							font-weight: bold;
							font-size: var(--base-px-16);
							color: #FFFFFF;
							line-height: var(--base-px-16);
							font-style: normal;
							text-transform: none;

							span {
								font-weight: 500;
								font-size: var(--base-px-12);
								color: #1A89F9;
								margin-left: var(--base-px-10)
							}
						}
					}
				}
			}
		}

		.event {
			padding: var(--base-px-24) var(--base-px-12) var(--base-px-60) var(--base-px-12);
			z-index: 1;
			top: var(--base-px-163);
			left: 0;
			right: 0;
			bottom: var(--base-px-12);
			background: #f2f3f7;
			border-radius: var(--base-px-20) var(--base-px-20) 0 0;

			.summary {
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: var(--base-px-16);
				height: var(--base-px-58);
				background: #fff;
				border-radius: var(--base-px-8);
				padding: var(--base-px-16);
			}


			.ranking {
				display: flex;
				align-items: center;
			}

			.title {
				height: var(--base-px-20);
				font-weight: bold;
				font-size: var(--base-px-14);
				color: #333333;
				line-height: var(--base-px-16);
				text-align: left;
				font-style: normal;
				text-transform: none;
			}

			.search {
				margin-top: var(--base-px-12);
				padding: 0 var(--base-px-16);
				height: var(--base-px-29);
				background: #7C9FDA;
				border-radius: var(--base-px-18) var(--base-px-18) var(--base-px-18) var(--base-px-18);
			}

			.event-list {
				margin-top: var(--base-px-12);
				overflow: auto;
				height: 100%;
				padding-bottom: var(--base-px-60);

				.card {
					height: var(--base-px-240);
					background: #FFFFFF;
					border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
					padding: var(--base-px-12);
					margin-bottom: var(--base-px-12);

					&:last-of-type {
						margin-bottom: 0;
					}

					.top {
						height: var(--base-px-48);

						.avatar {
							width: var(--base-px-48);
						}

						.content {
							width: 100%;
							padding-left: var(--base-px-12);

							&-top {
								height: var(--base-px-22);
								font-weight: bold;
								font-size: var(--base-px-16);
								color: #333333;
								line-height: var(--base-px-16);
								text-align: left;
								font-style: normal;
								text-transform: none;

								.status-badge {
									padding: 2px 8px;
									border-radius: 12px;
									font-size: var(--base-px-12);
									font-weight: 500;
									line-height: 1;
								}

								.status-enabled {
									background: #E7F7E7;
									color: #52C41A;
								}

								.status-disabled {
									background: #FFF2F0;
									color: #FF4D4F;
								}
							}

							&-bottom {
								margin-top: var(--base-px-4);
								height: var(--base-px-17);
								font-weight: 500;
								font-size: var(--base-px-12);
								color: #666666;
								line-height: var(--base-px-16);
								text-align: left;
								font-style: normal;
								text-transform: none;
							}
						}
					}

					.bottom {
						padding-top: var(--base-px-16);
						height: var(--base-px-120);

						&-item {
							width: 33.33%;

							&-top {
								height: var(--base-px-20);
								font-weight: 500;
								font-size: var(--base-px-14);
								color: #333333;
								line-height: var(--base-px-16);
								text-align: center;
								font-style: normal;
								text-transform: none;
							}

							&-bottom {
								margin-top: var(--base-px-3);
								height: var(--base-px-20);
								font-weight: bold;
								font-size: var(--base-px-14);
								color: #333333;
								line-height: var(--base-px-16);
								text-align: center;
								font-style: normal;
								text-transform: none;
							}
						}
					}

					.btns {
						display: flex;
						align-items: center;
						justify-content: flex-end;
					}
				}
			}
		}
	}

	.footer-new {
		background: rgb(242, 244, 248);
		color: rgb(204, 204, 204);
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		padding: var(--base-px-75) 0;
		line-height: var(--base-px-17);
		text-align: center;

		.privacy-entry {
			color: #2b60dd;
			opacity: .6;
			margin-left: var(--base-px-15);
			position: relative;
		}
	}
}
</style>
